//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import {
  fetchAppReviewDetailsData,
  updateAppReviewData,
} from "../../../features/AppReview/AppReviewSlice";
import { ExclamationIcon } from "../../icons";
import { useNavigate, useParams } from "react-router-dom";
import { useAppDispatch } from "../../../app/hooks";
import { getColorForLabel } from "../../../utils/colorUtils";
import Badge from "../../common/Badge";
import { fetchReviewDetailsData } from "../../../features/review/reviewSlice";
import { toast } from "sonner";
import LoadingBar from "react-top-loading-bar";
import { fetchQuestionEvaluationStepList } from "../../../features/jobEvaluation/JobApplicationSlice";
import { updateEvaluationQuestionValue } from "../../../features/AppReview/AppReviewSlice";
import { _baseRequest, COMMON } from "../../../utils/baseApi";
import TagInput from "./TagInput"

function AppEvaluationDetails({
  meetingId,
  evUserId,
  conductReview,
  setConductReview,
  currentAppReviewId,
  job: jobProp,
  app: appProp,
  quickData,
}: any) {
  const [meetingData, setMeetingData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(meetingData?.comment || "");
  const [jobQuestion, setJobQuestion] = useState([]);
  const [elements, setElements] = useState<FormElementEvaluation[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [applicationResponse, setApplicationResponse] = useState(null);
  const [applicationResponseLoading, setApplicationResponseLoading] =
    useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const {
    baseId,
    jobId: jobIdFromParams,
    applicationId: applicationIdFromParams,
    evaluationUserId,
  } = useParams<{
    baseId: string;
    jobId: string;
    applicationId: string;
    evaluationUserId: string;
  }>();

  const jobId = jobProp || jobIdFromParams;
  const applicationId = appProp || applicationIdFromParams || quickData;

  const dispatch = useAppDispatch();
  const userDetailsData = localStorage.getItem("jobByHiringTeamMembers");
  const baseMembers = userDetailsData ? JSON.parse(userDetailsData) : [];
  const [scoreCardName, setScoreCardName] = useState(null);
  const navigate = useNavigate();
  const [reviewComment, setReviewComment] = useState(null);
  const [reviewUpdateLoading, setReviewUpdateLoading] = useState(false);

  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const storedUserDetails = JSON.parse(
      localStorage.getItem("userDetails") || "{}",
    );
    setUserId(storedUserDetails?.id);
  }, []);

  const handleInputChange = (id: number, newValue: string) => {
    setElements((prev) =>
      prev.map((q) => {
        if (q.id === id) {
          return { ...q, answer: newValue };
        }
        return q;
      }),
    );
  };

  // Function to find host name by ID
  const getHostName = (hostId: any) => {
    if (!hostId) return { name: "Not specified", profilePic: null };

    const parsedHostId = parseInt(hostId, 10);
    const host = baseMembers.find((member) => member.user_id == parsedHostId);

    return host
      ? { name: host.name, profilePic: host.profile_pic }
      : { name: `Host ID: ${hostId}`, profilePic: null };
  };

  // Function to format date
  const formatDate = (dateString: any) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const handleReviewConduct = () => {
    setConductReview(true);
    navigate(
      `/${baseId}/job/${jobId}/app/${applicationId}/appreview/${meetingId || currentAppReviewId}/conduct-review`,
    );
  };

  const reviewerDetails = getHostName(meetingData?.review_by);

  useEffect(() => {
    if (meetingData?.comment) {
      setMessage(meetingData.comment);
    }
  }, [meetingData]);

  useEffect(() => {
    if (reviewComment !== null) {
      setMessage(reviewComment);
    }
  }, [reviewComment]);

  const canEdit = (element) => {
    // element.assigned_to might be a string or number, userId usually comes from params
    // Adjust the comparison depending on your data types
    return isEditMode && String(evUserId) === String(userId);
  };

  const renderEditableText = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
  ) => {
    const value = element[field] || "";
    const displayText = element.label || element.type || "No Value";

    const handleSave = (e: any) => {
      if (e) {
        handleUpdateQuestionValue(element, e);
      }
    };
    const editable = canEdit(element);

    return (
      <div className="flex items-start gap-2 py-2">
        <div className="flex flex-col gap-y-2 w-full">
          {editable ? (
            <input
              type="text"
              id={`input-${field}`}
              value={element.answer || ""}
              onBlur={(e) => handleSave(e.target.value)}
              onChange={(e) => handleInputChange(element.id, e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSave(e.target.value);
                }
              }}
              className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1
               h-[36px] ring-inset ring-gray-300 placeholder:text-[#52555a] font-medium focus:ring-2 
               focus:ring-inset focus:ring-indigo-600 sm:leading-6"
            />
          ) : (
            <p className="text-[14px] text-dark-black-100 p-1 bg-gray-50 rounded-md border mr-2">
              {element.answer || (
                <span className="text-gray-400 italic">No answer provided</span>
              )}
            </p>
          )}
        </div>
      </div>
    );
  };

  const renderEditableTextArea = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
  ) => {
    const value = element[field] || "";
    const displayText = element.label || element.type || "No Value";

    const handleSave = (e: any) => {
      if (e) {
        handleUpdateQuestionValue(element, e);
      }
    };
    const editable = canEdit(element);
    return (
      <div className="flex items-start gap-2 py-2">
        <div className="flex flex-col gap-y-2 w-full">
          {editable ? (
            <textarea
              rows={5}
              id={`input-${field}`}
              value={element.answer || ""}
              onBlur={(e) => handleSave(e.target.value)}
              onChange={(e) => handleInputChange(element.id, e.target.value)}
              onKeyPress={(e) => {
                if (e.key === "Enter") {
                  handleSave(e.target.value);
                }
              }}
              className="block w-full rounded-md border-0 py-1.5 text-[#52555a] text-[13px] shadow-sm ring-1
               h-[36px] px-2 ring-inset ring-gray-300 placeholder:text-[#52555a] font-medium focus:ring-2 
               focus:ring-inset focus:ring-indigo-600 sm:leading-6"
            />
          ) : (
            <p className="mr-2 text-[14px] text-dark-black-100 p-1 bg-gray-50 rounded-md border ">
              {element.answer || (
                <span className="text-gray-400 italic">No answer provided</span>
              )}
            </p>
          )}
        </div>
      </div>
    );
  };

  const renderSingleDropdown = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
    onToggleSelect: (value: string, data: any) => void,
  ) => {
    // Safer parsing logic
    let dropOptions = [];
    try {
      const parsed = JSON.parse(element.options);
      dropOptions = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      dropOptions = [];
    }
    const currentSelectedValues = element?.answer
      ? element.answer.split(",").map((item) => item.trim())
      : [];
    const editable = canEdit(element);
    return (
      <div className="flex flex-col items-start justify-between gap-2 py-2 relative">
        {/* Added flex-wrap and gap-2 for better layout than margin-left */}
        {editable ? (
          <div className="flex flex-wrap gap-2 w-full cursor-pointer ">
            {dropOptions?.map((option, optionIndex) => {
              // Check if this specific option is in the selected array
              const isSelected = currentSelectedValues.includes(option.label);
              return (
                <span
                  key={optionIndex + `dropdown`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent parent div click events
                    onToggleSelect(option.label, element);
                  }}
                  className={`
                cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200
                ${
                  isSelected
                    ? "bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600/10 border-indigo-600" // Active Styles
                    : "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent hover:bg-gray-100" // Inactive Styles
                }
              `}
                >
                  {option.label}
                  {/* Optional: Add a checkmark if selected */}
                  {/* {isSelected && <span className="ml-1.5 font-bold">✓</span>} */}
                </span>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-wrap gap-2 w-full">
            {currentSelectedValues?.map((option, optionIndex) => {
              return (
                <span
                  key={optionIndex}
                  className="font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200 bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent "
                >
                  {option || (
                    <span className="text-gray-400 italic">
                      No answer provided
                    </span>
                  )}
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const renderRating = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
    onToggleSelect: (value: string, data: any) => void,
  ) => {
    // Safer parsing logic
    let dropOptions = [];
    try {
      const parsed = JSON.parse(element.options);
      dropOptions = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      dropOptions = [];
    }
    const currentSelectedValues = element?.answer
      ? element.answer.split(",").map((item) => item.trim())
      : [];

    const editable = canEdit(element);
    return (
      <div className="flex flex-col items-start justify-between gap-2 py-2 relative">
        {/* Added flex-wrap and gap-2 for better layout than margin-left */}
        {editable ? (
          <div className="flex flex-wrap gap-2 w-full cursor-pointer">
            {dropOptions?.map((option, optionIndex) => {
              // Check if this specific option is in the selected array
              const isSelected = currentSelectedValues.includes(option.label);
              return (
                <span
                  key={optionIndex + `dropdown`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent parent div click events
                    onToggleSelect(option.label, element);
                  }}
                  className={`
                cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200
                ${
                  isSelected
                    ? "bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600/10 border-indigo-600" // Active Styles
                    : "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent hover:bg-gray-100" // Inactive Styles
                }
              `}
                >
                  {option.label}
                  {/* Optional: Add a checkmark if selected */}
                  {/* {isSelected && <span className="ml-1.5 font-bold">✓</span>} */}
                </span>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-wrap gap-2 w-full">
            {currentSelectedValues?.map((option, optionIndex) => {
              return (
                <span
                  key={optionIndex}
                  className="font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200 bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent "
                >
                  {option || (
                    <span className="text-gray-400 italic">
                      No answer provided
                    </span>
                  )}
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  };

  const renderDropdownMulti = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
    onToggleSelect: (value: string, data: any) => void,
  ) => {
    // Safer parsing logic
    let dropOptions = [];
    try {
      const parsed = JSON.parse(element.options);
      dropOptions = Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      dropOptions = [];
    }
    const currentSelectedValues = element?.answer
      ? element.answer.split(",").map((item) => item.trim())
      : [];
    const editable = canEdit(element);
    return (
      <div className="c flex flex-col items-start justify-between gap-2 py-2 relative">
        {/* Added flex-wrap and gap-2 for better layout than margin-left */}
        {editable ? (
          <div className="flex flex-wrap gap-2 w-full ursor-pointer">
            {dropOptions?.map((option, optionIndex) => {
              // Check if this specific option is in the selected array
              const isSelected = currentSelectedValues.includes(option.label);

              return (
                <span
                  key={optionIndex + `multi`}
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent parent div click events
                    onToggleSelect(option.label, element);
                  }}
                  className={`
                cursor-pointer font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200
                ${
                  isSelected
                    ? "bg-indigo-600 text-white ring-1 ring-inset ring-indigo-600/10 border-indigo-600" // Active Styles
                    : "bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent hover:bg-gray-100" // Inactive Styles
                }
              `}
                >
                  {option.label}
                </span>
              );
            })}
          </div>
        ) : (
          <div className="flex flex-wrap gap-2 w-full">
            {currentSelectedValues?.map((option, optionIndex) => {
              return (
                <span
                  key={optionIndex}
                  className="font-normal text-[13px] capitalize inline-flex items-center rounded-md px-2 py-0.5 border transition-colors duration-200 bg-gray-50 text-gray-600 ring-1 ring-inset ring-gray-500/10 border-transparent  "
                >
                  {option || (
                    <span className="text-gray-400 italic">
                      No answer provided
                    </span>
                  )}
                </span>
              );
            })}
          </div>
        )}
      </div>
    );
  };
  const renderTag = (
    element: FormElement,
    index: number,
    field: keyof FormElement,
    label: string,
    onToggleSelect: (value: string, data: any) => void,
  ) => {
    
    const editable = canEdit(element);

 
    return (
    <TagInput
      value={element.answer}
      editable={editable}
      onChange={(val) => onToggleSelect(val, element)}
    />
    );
  };

  // Handler to toggle selection
  const handleMultiDropdownClick = (tagLabel: string, data: any) => {
    const currentAnswers = tagLabel.answer
      ? tagLabel.answer.split(",").map((s) => s.trim())
      : [];

    let newAnswers;
    if (currentAnswers.includes(tagLabel)) {
      newAnswers = currentAnswers.filter((t) => t !== tagLabel);
    } else {
      newAnswers = [...currentAnswers, tagLabel];
    }
    const newValueString = newAnswers.join(",");
    setElements((prev) =>
      prev.map((q) => {
        if (q.id === data.id) {
          return { ...q, answer: newValueString };
        }
        return q;
      }),
    );
    handleUpdateQuestionValue(data, newValueString);
  };

  // Pass handler
  const handleSingleDropdownClick = (tagLabel: string, data: any) => {
    const currentAnswer = data.answer;
    let newAnswer = tagLabel;
    setElements((prev) =>
      prev.map((q) => {
        if (q.id === data.id) {
          return { ...q, answer: newAnswer };
        }
        return q;
      }),
    );

    handleUpdateQuestionValue(data, newAnswer);
  };

  const handleRating = (tagLabel: string, data: any) => {
    const currentAnswer = data.answer;
    let newAnswer = tagLabel;
    setElements((prev) =>
      prev.map((q) => {
        if (q.id === data.id) {
          return { ...q, answer: newAnswer };
        }
        return q;
      }),
    );

    handleUpdateQuestionValue(data, newAnswer);
  };

  const handleUpdateQuestionValue = async (element, inputValue) => {
    try {
      const res = await dispatch(
        updateEvaluationQuestionValue({
          data: {
            base_id: Number(baseId),
            job_id: jobId,
            app_id: applicationId,
            answers: [{ id: element.id, value: inputValue }],
            job_evaluation_run: element.job_evaluation_run,
          },
        }),
      ).unwrap();

      // setOpenDeleteModalExp(false);
      if (res.status === 200) {
        toast.success("Updated successfully!");
      }
    } finally {
      // setDeleteLoadingExp(false);
    }
  };

  useEffect(() => {
    const fetchInitialData = async () => {
      if (String(evUserId) !== String(userId) && String(evUserId) !== "0") {
        setApplicationResponse([]);
        return;
      }

      let fullUrl = `${COMMON.apiBaseUrl()}/v1/job-evaluation/${baseId}/${jobId}/${applicationId}/answers.list?assigned_to=${evUserId}`;

      try {
        setApplicationResponseLoading(true);
        const response = await _baseRequest(fullUrl, "GET");

        if (response.status === 200) {
          setApplicationResponse(response?.data);
        }
      } catch (error) {
        console.error("Error fetching initial data:", error);
      } finally {
        setApplicationResponseLoading(false);
      }
    };

    if (applicationId) {
      fetchInitialData();
    }
  }, [applicationId, evUserId, userId]);

  useEffect(() => {
    const fetchSteps = async () => {
      // Ensure we have both IDs AND the answers have finished loading
      const isEvaluator = String(evUserId) !== String(userId)&& String(evUserId) !== "0";
      if (jobId && baseId && (applicationResponse || isEvaluator)) {
        setIsLoading(true);
        try {
          const response = await dispatch(
            fetchQuestionEvaluationStepList({ baseId, jobId }),
          ).unwrap();

          // FIX: Access the 'questions' array inside the data object
          const questionData = response.data.questions;
          if (isEvaluator) {
            // SKIP MAP BINDING: Just set questions with empty answers
            const evaluatorQuestions = questionData.map((q) => ({
              ...q,
              answer: null, // Start fresh for the evaluator
              job_evaluation_run: null,
            }));
            setElements(evaluatorQuestions);
          } else {
            // BIND ANSWERS: For other users viewing the result
            const answerMap = new Map(
              applicationResponse.map((item) => [item.id, item.answer]),
            );
            const jobEvaluationRunMap = new Map(
              applicationResponse.map((item) => [
                item.id,
                item.job_evaluation_run,
              ]),
            );

            const updatedQuestions = questionData.map((q) => ({
              ...q,
              answer: answerMap.get(q.id) || null,
              job_evaluation_run: jobEvaluationRunMap.get(q.id) || null,
            }));
            setElements(updatedQuestions);
          }
        } catch (error) {
          console.error("Failed to fetch integration steps:", error);
        } finally {
          setIsLoading(false);
        }
      }
    };

    fetchSteps();
  }, [dispatch, baseId, jobId, applicationResponse]);

  
  const renderElement = (element: FormElement, index: number) => {
    switch (element.type) {
      case "text":
        return renderEditableText(element, index, "headerText", "Text");
      case "long_text":
        return renderEditableTextArea(element, index, "headerText", "Text");
      case "number":
        return renderEditableText(element, index, "headerNumber", "Text");
      case "rating":
        return renderRating(
          element,
          index,
          "headerText",
          "Dropdown",
          handleRating,
        );
      case "single_select":
        return renderSingleDropdown(
          element,
          index,
          "headerText",
          "Dropdown",
          handleSingleDropdownClick,
        );
      case "multi_select":
        return renderDropdownMulti(
          element,
          index,
          "Dropdownmulti",
          "Dropdownmulti",
          handleMultiDropdownClick,
        );
      case "tags":
        return renderTag(
          element,
          index,
          "Dropdownmulti",
          "Dropdownmulti",
          handleMultiDropdownClick,
        );
      default:
        return null;
    }
  };

  // if (isLoading)
  //   return (
  //     <div
  //       className="flex items-center justify-center relative z-50"
  //       style={{ height: "calc(100vh - 191px)" }}
  //     >
  //       <div className="simple-spinner-loader">
  //         <span></span>
  //       </div>
  //     </div>
  //   );

  if (error)
    return <div className="text-center py-4 text-red-500">Error: {error}</div>;

  if (!elements)
    return (
      <div className="w-full mt-5 flex h-[300px] justify-center items-center flex-col gap-y-3">
        <ExclamationIcon />
        <p className="text-[#0000007a] text-[13px]">No results found</p>
      </div>
    );

  return (
    <div className="max-w-2xl mx-auto bg-white p-0">
      <>
        <div className="mb-5 gap-x-3">
          <div className="flex items-start flex-col gap-5">
            <div className="flex items-center justify-between w-full">
              <div className="flex items-center gap-x-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={24}
                  height={24}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-clipboard-list w-[1.1rem] h-[1.1rem] text-[#808080]"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2" />
                  <path d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z" />
                  <path d="M9 12l.01 0" />
                  <path d="M13 12l2 0" />
                  <path d="M9 16l.01 0" />
                  <path d="M13 16l2 0" />
                </svg>

                <span className="font-medium text-dark-black-200  mr-1 text-[15px] flex items-center gap-[6px] ">
                  Evaluation
                </span>
              </div>

              {String(evUserId) === String(userId) && (
                <button
                  onClick={() => setIsEditMode(!isEditMode)}
                  className={`px-3 py-1 text-xs font-medium rounded-md transition-colors ${
                    isEditMode
                      ? "bg-red-50 text-red-600 border border-red-200"
                      : "text-white bg-indigo-600  border border-indigo-200"
                  }`}
                >
                  {isEditMode ? "Cancel Editing" : "Edit Evaluation"}
                </button>
              )}
            </div>

            <div className="space-y-4 w-full">
              {isLoading && (
                <div
                  className="flex items-center justify-center relative z-50"
                  style={{ height: "calc(50vh - 191px)" }}
                >
                  <div className="simple-spinner-loader">
                    <span></span>
                  </div>
                </div>
              )}

              {elements.length > 0 &&
                !isLoading &&
                elements.map((element, index) => (
                  <div key={index} className="px-1">
                    <div className="flex flex-col mb-1">
                      <span className="text-sm font-medium text-gray-700">
                        {element?.question}
                      </span>
                      {element?.instruction && (
                        <span className="text-xs text-gray-500">
                          ( {element?.instruction} )
                        </span>
                      )}
                    </div>
                    {/* <hr className="mt-1 mb-0"></hr> */}
                    {renderElement(element, index)}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default AppEvaluationDetails;
